import React, { useState, useEffect, useRef, useCallback } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  Checkbox,
  Box,
  SwipeableDrawer,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Tooltip,
  Chip,
  Avatar,
  Switch,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle";
import { toast } from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import sample_duplicate_check_candidates from "../../images/files/duplicate_check_candidates.xlsx";
import "../../css/candidate-profile.css";
import * as XLSX from "xlsx";
import ViewIcon from "@material-ui/icons/Visibility";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function DuplicateCheckCandidates(props) {
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const fileInputRef = useRef(null);
  const token = localStorage.getItem("token");
  const positions = [toast.POSITION.TOP_RIGHT];
  const [file, setFile] = useState(null);
  const [uploadExistFile, setUploadExistFile] = useState(null);
  const [viewSecureCandiData, setViewSecureCandiData] = useState(null);
  const [activeModal, setActiveModal] = useState(null);

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [secureCandiData, setSecureCandiData] = useState([]);
  const [IsCheckGlobal, setIsCheckGlobal] = useState(() => {
    const storedValue = localStorage.getItem("duplication-check-global");
    return storedValue === null ? false : storedValue === "true";
  });

  const [userName, setUserName] = useState([]);
  const [selectedRecruiters, setSelectedRecruters] = useState([]);

  var [notificationsPosition] = useState(2);
  var [errorToastId, setErrorToastId] = useState(null);
  const filterRef = useRef(null);
  const [modalPendingOpen, setModalPendingOpen] = React.useState(false);

  const handleOpenModal = (value, type) => {
    if (type === "vendor-info") {
      fetchGroupVendorDetails(value.id);
    }

    setViewSecureCandiData(value);
    setActiveModal(type);
  };

  const handleCloseModal = () => {
    setViewSecureCandiData(null);
    setActiveModal(null);
  };

  const handleCandidateUploadOpen = () => {
    setModalPendingOpen(true);
  };

  const handleCandidateUploadClose = () => {
    setModalPendingOpen(false);
  };

  const getFilterData = async () => {
    if (!filterRef.current) return;

    const form = filterRef.current;
    const fromDate = form["fromDate"].value;
    const toDate = form["toDate"].value;

    const payload = {
      page: 1,
      fromDate,
      toDate,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}candidateEntryGroup/getAll`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status === true) {
        setSecureCandiData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      } else {
        console.warn("No data returned");
      }
    } catch (error) {
      console.error("Filter fetch error:", error);
    }
  };

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const validationSchema = Yup.object().shape({
    groupName: Yup.string().required("Group Name is Required"),
    candidates: Yup.array()
      .of(
        Yup.object().shape({
          candidateEmail: Yup.string().required("Missing Email"),
          countryCode: Yup.string().required("Missing Country Code"),
          candidateMobile: Yup.string().required("Missing Mobile"),
          requirementName: Yup.string().required("Missing Requirement Name"),
        }),
      )
      .min(1, "At least one candidate info is required"),
  });

  const updateValidationSchema = Yup.object().shape({
    candidates: Yup.array()
      .of(
        Yup.object().shape({
          candidateEmail: Yup.string().required("Missing Email"),
          countryCode: Yup.string().required("Missing Country Code"),
          candidateMobile: Yup.string().required("Missing Mobile"),
          requirementName: Yup.string().required("Missing Requirement Name"),
        }),
      )
      .min(1, "At least one candidate info is required"),
  });

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    register: updateRegister,
    setValue: updateSetValue,
    handleSubmit: updateHandleSubmit,
    formState: { errors: updateErrors },
  } = useForm({
    resolver: yupResolver(updateValidationSchema),
  });

  const assignSchema = Yup.object().shape({
    recruiterId: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required("Recruiter ID is required"),
        }),
      )
      .min(1, "At least one recruiter must be selected")
      .required("Recruiter selection is required"),
  });

  const onRemoveSelectedRecruiters = (option) => async () => {
    setSelectedRecruters((value) => value.filter((v) => v.id !== option.id));
    await handleRemoveVendorFromGroup(option.whitelistId);
  };

  const {
    control: assignControl,
    formState: { errors: assignErrors, isSubmitting: assignIsSubmitting },
    handleSubmit: assignSubmit,
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(assignSchema),
  });

  useEffect(() => {
    fetchData({ page });
    const storedValue = localStorage.getItem("duplication-check-global");
    if (storedValue === null) {
      fetchCheckDuplicationListGlobally();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, page]);

  const getUserName = useCallback(async () => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/allRecruiterList`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          const responseData = response.data.data;
          const freelanceUsers = responseData.filter(
            (item) => item.user.roleName === "SUBCONTRACT",
          );

          const userDropList = freelanceUsers.map((item) => ({
            id: item.user.id,
            firstName: item.firstName,
            lastName: item.lastName,
          }));
          setUserName(userDropList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // const getAssigendVendorsData = useCallback(async () => {
  //   setLoader(true);
  //   axios({
  //     method: "post",
  //     url: `${process.env.REACT_APP_SERVER}admin/getAssigendData`,
  //     data: {
  //       roleName: "SUBCONTRACT",
  //       requirementId: requirementIdParam,
  //     },
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: token,
  //     },
  //   })
  //     .then(function (response) {
  //       if (response.data.status === true) {
  //         setVendorsData(response.data.data);
  //         setCount(response.data.count);
  //       }
  //       setLoader(false);
  //     })
  //     .catch((err) => {
  //       setLoader(false);
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    // getAssigendVendorsData();
    getUserName();
  }, [getUserName]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async ({ page }) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}candidateEntryGroup/getAll`,
      data: {
        page: page,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          setLoader(false);
          setSecureCandiData(response.data.data);
          setCount(response.data.count);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchCheckDuplicationListGlobally = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}candidateEntryGroup/getActiveness`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        setIsCheckGlobal(response.data.data?.toCheckWhitelist);
        const toCheck = response.data.data?.toCheckWhitelist ?? false;
        localStorage.setItem("duplication-check-global", String(toCheck));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGroupVendorDetails = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}candidateEntryGroup/getVendors/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const reponseData = response.data.data;
        const alreadySelectedVendors = reponseData?.map((item) => {
          return {
            id: item.user.id,
            firstName: item.user.recruiter.firstName,
            lastName: item.user.recruiter.lastName,
            whitelistId: item.id,
          };
        });
        setSelectedRecruters(alreadySelectedVendors);
      }
    } catch (error) {
      console.log(error);
    }
  };

  async function handleAddBulkCandidates(values) {
    if (!file) {
      handleNotificationCall("error", "Select a Upload File");
      return;
    }

    try {
      setLoader(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}duplicateCheck/bulkAdd`,
        data: {
          groupName: values.groupName,
          excelName: file.name,
          data: values.candidates,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        handleCandidateUploadClose();
        setFile(null);
        fetchData({ page: 1 });
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleUpdateBulkCandidates(values) {
    try {
      setLoader(true);
      const response = await axios({
        method: "put",
        url: `${process.env.REACT_APP_SERVER}duplicateCheck/update`,
        data: {
          groupId: viewSecureCandiData.id,
          excelName: uploadExistFile.name,
          data: values.candidates,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        setUploadExistFile(null);
        handleCloseModal();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleStatus(id, value) {
    setLoader(true);
    axios({
      method: "patch",
      url: `${process.env.REACT_APP_SERVER}candidateEntryGroup/toggleActiveness/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        const switchState = secureCandiData.map((item) => {
          if (item.id === id) {
            return { ...item, isActive: Boolean(value) };
          }
          return item;
        });
        setSecureCandiData(switchState);
        handleNotificationCall("success", response.data.data);
      }
    });
  }

  function handleAssignRequirements(values) {
    return new Promise((resolve) => {
      setLoader(true);
      const selectRecruitersID = selectedRecruiters.map((item) => item.id);

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}candidateEntryGroup/whitelist/add/vendors`,
        data: {
          vendorIds: selectRecruitersID,
          groupId: viewSecureCandiData.id,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        resolve();
        if (response.data.status === true) {
          handleNotificationCall("success", response.data.message);
          handleCloseModal();
        } else {
          handleNotificationCall("error", response.data.message);
        }
        setLoader(false);
      });
    });
  }

  const handleRemoveVendorFromGroup = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER}candidateEntryGroup/removeVendor/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  var table_data = {};

  var table_columns = [];

  table_columns = [
    {
      name: "S.No",
    },
    {
      name: "Date",
    },
    {
      name: "Title",
    },
    {
      name: "Active / Inactive",
    },
    {
      name: "Assign to Vendors",
    },
    {
      name: "Update Candidates",
    },
    {
      name: "Action",
    },
    {
      name: "Last Updated Date",
    },
  ];

  table_data = secureCandiData.map((item, index) => {
    return [
      <>{page !== 0 ? 10 * page - 10 + index + 1 : index + 1}</>,
      moment(item.createdAt).format("DD-MM-YYYY"),
      item.groupName,
      <>
        <Switch
          checked={Boolean(item.isActive)}
          onChange={(e) => {
            handleStatus(item.id, e.target.checked);
          }}
          color="primary"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
      </>,
      <>
        <Button
          variant="contained"
          color="primary"
          size="small"
          type="button"
          onClick={() => handleOpenModal(item, "vendor-info")}
        >
          Assigned Vendors
        </Button>
      </>,
      <>
        <Grid container className={classes.space}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            onClick={(e) => {
              handleOpenModal(item, "upload-more");
            }}
          >
            Upload More Candidates
          </Button>
        </Grid>
      </>,
      <>
        <Grid container className={classes.space}>
          <Tooltip title="View Candidates" placement="bottom" aria-label="view">
            <ViewIcon
              className={classes.toolIcon}
              onClick={() => {
                window.open(
                  `/app/checking_candidates?groupId=${item.id}`,
                  "_blank",
                  "noopener,noreferrer",
                );
              }}
            />
          </Tooltip>

          <Tooltip
            title="Vendor Posted Candidates"
            placement="bottom"
            aria-label="view"
          >
            <AssignmentIndIcon
              className={`${classes.toolIconCustomColor} ${classes.purple}`}
              onClick={() => {
                window.open(
                  `/app/vendor_shared_candidates?groupId=${item.id}`,
                  "_blank",
                  "noopener,noreferrer",
                );
              }}
            />
          </Tooltip>

          <Button
            variant="contained"
            color="secondary"
            size="small"
            type="button"
            onClick={(e) => {
              handleOpenModal(item, "delete-record");
            }}
          >
            Delete Entire List
          </Button>
        </Grid>
      </>,
      moment(item.updatedAt).format("DD-MM-YYYY"),
    ];
  });

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const HeaderElements = () => (
    <>
      <p>Total : {count}</p>
    </>
  );

  const handleChangeDuplicateCheck = async (event) => {
    const newValue = event.target.checked; // ✅ Invert again to match logical state

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}candidateEntryGroup/toggleCheckwhitelist`,
        { toCheckWhitelist: newValue },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        const checkGlobal = response.data.data.isCheckGlobally;
        setIsCheckGlobal(newValue);
        localStorage.setItem("duplication-check-global", String(checkGlobal));
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
        const checkGlobal = response.data.data.isCheckGlobally;
        setIsCheckGlobal(newValue);
        localStorage.setItem("duplication-check-global", String(checkGlobal));
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const handleUploadExcelFile = (e) => {
    const dataFile = e.target.files?.[0];
    if (!dataFile) return;

    setFile(dataFile);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const records = XLSX.utils.sheet_to_json(sheet);

      const candidateCollection = records?.map((item) => ({
        // candidateName: item["Name"],
        candidateEmail: item["Email"],
        countryCode: item["Country Code"],
        candidateMobile: item["Mobile"],
        requirementName: item["Requirement Name"],
      }));

      setValue("candidates", candidateCollection);
      // setEmpPayslipData(records);
    };
    reader.readAsArrayBuffer(dataFile);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleUpdateNewCandidateExcelFile = (e) => {
    if (!e.target.files) {
      return;
    }
    const dataFile = e.target.files[0];
    setUploadExistFile(dataFile);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const records = XLSX.utils.sheet_to_json(sheet);

      const candidateCollection = records?.map((item) => ({
        candidateEmail: item["Email"],
        countryCode: item["Country Code"],
        candidateMobile: item["Mobile"],
        requirementName: item["Requirement Name"],
      }));

      updateSetValue("candidates", candidateCollection);
      // setEmpPayslipData(records);
    };
    reader.readAsArrayBuffer(dataFile);
  };

  const formatSize = (size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleDeleteEntireRecord = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_SERVER}candidateEntryGroup/removeGroup/${viewSecureCandiData.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchData({ page });
        handleCloseModal();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Secured Candidates Groups" />
        </Grid>

        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <>
            <div className={classes.lgButton}>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddCircleIcon />}
                className={classes.addUser}
                color="primary"
                onClick={handleCandidateUploadOpen}
              >
                Upload Candidates
              </Button>
            </div>

            <div className={classes.smButton}>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddCircleIcon />}
                className={classes.addUser}
                color="primary"
                onClick={handleCandidateUploadOpen}
              >
                Upload
              </Button>
            </div>
          </>
        </Grid>
      </Grid>

      {/* <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
          <TextField
            name="fromDate"
            label="From"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            type="date"
            defaultValue={fromDate}
            onChange={handleFromDateChange}
          />

          <TextField
            name="toDate"
            label="To"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            type="date"
            defaultValue={toDate}
            onChange={handleToDateChange}
          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              type="submit"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={9}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              margin: "12px 0px",
            }}
          >
            <FormControl className={classes.margin}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={IsCheckGlobal} // ✅ Inverted logic for UI display
                    onChange={handleChangeDuplicateCheck}
                  />
                }
                label="Organization policy option - Vendor candidate profile upload duplicate policy - Click the checkbox to enable all requirements duplicate check else duplicate check is only for each for each requirement indepentantly"
              />

              <Typography variant="inherit" color="error">
                {errors.isPfPercentage?.message}
              </Typography>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title={""}
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              print: false,
              download: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={table_columns}
            data={table_data}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleCandidateUploadClose}
        open={modalPendingOpen}
        width="sm"
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Upload .XLSX File
            </Typography>
            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCandidateUploadClose}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(handleAddBulkCandidates)}>
            <Grid item xs={12}>
              <InputLabel shrink htmlFor="groupName">
                Group Name
              </InputLabel>
              <FormControl className={classes.margin}>
                <TextField
                  InputProps={{ disableUnderline: true }}
                  classes={{ root: classes.customTextField }}
                  size="small"
                  placeholder="Group Name"
                  name="groupName"
                  {...register("groupName")}
                  error={errors.groupName ? true : false}
                />

                <Typography variant="inherit" color="error">
                  {errors.groupName?.message}
                </Typography>
              </FormControl>
            </Grid>
            <Grid className={classes.filterGap + " " + classes.center}>
              <div className="upload-container">
                <div className="upload-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="upload-icon"
                    viewBox="0 0 32 32"
                  >
                    <title>file_type_excel2</title>
                    <path
                      d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                      style={{ fill: "#20744a", fillRule: "evenodd" }}
                    />
                    <rect
                      x="22.487"
                      y="7.439"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="10.94"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="14.441"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="17.942"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="21.443"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <polygon
                      points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                      style={{ fill: "#ffffff", fillRule: "evenodd" }}
                    />
                  </svg>

                  <span className="upload-text">
                    Click to upload your files here
                  </span>
                  <span className="upload-subtext">(only .XLSX Format)</span>
                </div>

                <input
                  type="file"
                  name="upload-file"
                  accept=".xlsx"
                  className="upload-input"
                  ref={fileInputRef}
                  onChange={handleUploadExcelFile}
                />
              </div>
            </Grid>
            {file && (
              <Grid>
                <div className="file-card">
                  <div className="file-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="upload-icon"
                      viewBox="0 0 32 32"
                    >
                      <title>file_type_excel2</title>
                      <path
                        d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                        style={{ fill: "#20744a", fillRule: "evenodd" }}
                      />
                      <rect
                        x="22.487"
                        y="7.439"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="10.94"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="14.441"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="17.942"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="21.443"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <polygon
                        points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                        style={{ fill: "#ffffff", fillRule: "evenodd" }}
                      />
                    </svg>
                  </div>
                  <div className="file-info">
                    <div className="file-name">{file.name}</div>
                    <div className="file-size">{formatSize(file.size)}</div>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setFile(null);
                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                    }}
                    className="file-action"
                  >
                    Remove
                  </button>
                </div>
              </Grid>
            )}
            <Grid className={classes.center}>
              <Grid style={{ padding: "10px 0px" }}>
                Sample excel format to upload your candidate details (Only then
                Vendor / Freelancer can check duplicate)
                <a
                  href={sample_duplicate_check_candidates}
                  style={{ marginLeft: "4px" }}
                  className={classes.aLink}
                  download
                >
                  download
                </a>
              </Grid>
            </Grid>

            <div className={classes.sendWhatsapp}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
              >
                Yes, Submit
              </Button>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                type="button"
                onClick={handleCandidateUploadClose}
              >
                No, Cancel
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleCloseModal}
        open={activeModal === "upload-more"}
        width="sm"
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Upload New .XLSX File
            </Typography>
            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCloseModal}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={updateHandleSubmit(handleUpdateBulkCandidates)}>
            <Grid className={classes.filterGap + " " + classes.center}>
              <div className="upload-container">
                <div className="upload-content">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="upload-icon"
                    viewBox="0 0 32 32"
                  >
                    <title>file_type_excel2</title>
                    <path
                      d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                      style={{ fill: "#20744a", fillRule: "evenodd" }}
                    />
                    <rect
                      x="22.487"
                      y="7.439"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="10.94"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="14.441"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="17.942"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="21.443"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <polygon
                      points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                      style={{ fill: "#ffffff", fillRule: "evenodd" }}
                    />
                  </svg>

                  <span className="upload-text">
                    Click to upload your files here
                  </span>
                  <span className="upload-subtext">(only .XLSX Format)</span>
                </div>

                <input
                  type="file"
                  name="upload-file"
                  accept=".xlsx"
                  className="upload-input"
                  onChange={handleUpdateNewCandidateExcelFile}
                />
              </div>
            </Grid>
            {uploadExistFile && (
              <Grid>
                <div className="file-card">
                  <div className="file-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                      <title>file_type_excel2</title>
                      <path
                        d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                        style={{ fill: "#20744a", fillRule: "evenodd" }}
                      />
                      <rect
                        x="22.487"
                        y="7.439"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="10.94"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="14.441"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="17.942"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <rect
                        x="22.487"
                        y="21.443"
                        width="4.323"
                        height="2.2"
                        style={{ fill: "#20744a" }}
                      />
                      <polygon
                        points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                        style={{ fill: "#ffffff", fillRule: "evenodd" }}
                      />
                    </svg>
                  </div>
                  <div className="file-info">
                    <div className="file-name">{uploadExistFile.name}</div>
                    <div className="file-size">
                      {formatSize(uploadExistFile.size)}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setUploadExistFile(null)}
                    className="file-action"
                  >
                    Remove
                  </button>
                </div>
              </Grid>
            )}
            <Grid className={classes.center}>
              <Grid style={{ padding: "10px 0px" }}>
                Sample excel format to upload your candidate details (Only then
                Vendor / Freelancer can check duplicate)
                <a
                  href={sample_duplicate_check_candidates}
                  style={{ marginLeft: "4px" }}
                  className={classes.aLink}
                  download
                >
                  download
                </a>
              </Grid>
            </Grid>

            <div className={classes.sendWhatsapp}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
              >
                Yes, Send
              </Button>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                type="button"
                onClick={handleCloseModal}
              >
                No, Cancel
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleCloseModal}
        open={activeModal === "vendor-info"}
        width="md"
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Vendor Details
            </Typography>
            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCloseModal}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={assignSubmit(handleAssignRequirements)}>
            <div style={{ margin: "14px 14px 0px 14px" }}>
              <div className={classes.selectedAssignedRecruitersContainer}>
                {selectedRecruiters.map((option) => {
                  const firstName = option.firstName;
                  const lastName = option.lastName;
                  let chipLabel = `${firstName} ${lastName}`;
                  return (
                    <Chip
                      key={option.id}
                      label={chipLabel}
                      onDelete={onRemoveSelectedRecruiters(option)}
                      avatar={<Avatar> {firstName.split("")[0]}</Avatar>}
                      className={classes.EditRecUserChip}
                      clickable
                      color="primary"
                      variant="outlined"
                    />
                  );
                })}
              </div>
              <div style={{ display: "flex", alignItems: "end", gap: "10px" }}>
                <FormControl>
                  <InputLabel shrink htmlFor="recruiterId">
                    Vendors{" "}
                  </InputLabel>
                  <Controller
                    name="recruiterId"
                    control={assignControl}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        multiple
                        id="checkboxes-tags-demo"
                        options={userName}
                        value={selectedRecruiters}
                        disableCloseOnSelect
                        getOptionLabel={(option) => {
                          const firstName = option.firstName;
                          const lastName = option.lastName;
                          let label = `${firstName} ${lastName}`;
                          return label;
                        }}
                        onChange={(e, newValue) => {
                          field.onChange(newValue);
                          setSelectedRecruters(newValue);
                        }}
                        renderTags={() => null}
                        renderOption={(option, { selected }) => {
                          const firstName = option.firstName;
                          const lastName = option.lastName;
                          let label = `${firstName} ${lastName}`;

                          return (
                            <div style={{ fontSize: "14px" }}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8, padding: 0 }}
                                checked={selected}
                              />
                              {label}
                            </div>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="recruiterId"
                            variant="filled"
                          />
                        )}
                      />
                    )}
                  />
                  <Typography
                    variant="inherit"
                    color="error"
                    style={{ position: "absolute", bottom: "-22px", left: 0 }}
                  >
                    {assignErrors.recruiterId?.message}
                  </Typography>
                </FormControl>

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={assignIsSubmitting}
                  type="submit"
                  className={classes.mt16}
                >
                  Assign
                </Button>
              </div>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        onClose={handleCloseModal}
        aria-labelledby="dialog-title"
        open={activeModal === "delete-record"}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Confirmation
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCloseModal}
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <Typography variant="subtitle2" style={{ textAlign: "left" }}>
            Are you sure want to delete this entire group secured candidate
            profiles? Once executed, this action will permanently remove the
            table group from the Refo server.
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={secureCandiData <= 0}
              onClick={handleDeleteEntireRecord}
            >
              Yes, Confirm
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleCloseModal}
            >
              No, Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {/* {list("right")} */}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
